import React, { useEffect } from 'react';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';

import { connect, useSelector } from 'react-redux';
// import FinancialStatement from "../components/templates/academic/oneStudent/FinancialStatement";
import LayoutTeacher from '../components/shared/teacher-layout/LayoutTeacher';
import { checkRoles } from '../helpers/roles.helper';
import useHotjar from '../hooks/useHotjar';
import useLayout from '../hooks/useLayout';

const StudentRoute = (props) => {
    const {
        layout = 'common',
        isAuthenticated,
        permissionRoles,
        blockedRoles,
        user,
        title = false,
        component: Component,
        ...rest
    } = props;

    // Hooks
    const history = useHistory();
    const activeRol = useSelector((state) => state.auth.activeRol);
    const { setMenu, clearMenu } = useLayout();
    useHotjar();

    const { pathname } = useLocation();
    const urlRedirect = pathname.slice(1);

    // FUNCTION
    const renderLayout = (layout, Component) => {
        const cases = {
            common: (
                <LayoutTeacher title={title} minPadding={true}>
                    {Component}
                </LayoutTeacher>
            ),
            course: (
                <LayoutTeacher title={title} minPadding={true}>
                    {Component}
                </LayoutTeacher>
            ),
        };

        return cases[layout] || cases['common'];
    };

    if (!checkRoles(permissionRoles) || blockedRoles.includes(activeRol)) {
        history.push('../not-found');
    }

    // RETURN
    return (
        <Route
            {...rest}
            component={(props) =>
                isAuthenticated ? (
                    renderLayout(layout, <Component {...props} />)
                ) : (
                    <Redirect
                        to={
                            urlRedirect === 'not-found' ||
                            urlRedirect === 'logout' ||
                            urlRedirect === 'cookies'
                                ? '/auth'
                                : `/auth?redirect=${urlRedirect}`
                        }
                    />
                )
            }
        />
    );
};

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.auth.user,
    user: state.auth.user,
    blockedStatus: state.userStatus.blockedStatus,
});

export default connect(mapStateToProps)(StudentRoute);
